import isMandatorySupplementaryCover
  from '@@custom/mhexpat/__custom/helpers/isMandatorySupplementaryCover.mjs';

const isSupplementaryCoverLocked = (cover) =>
  isMandatorySupplementaryCover(cover.moduleCode);

export default isSupplementaryCoverLocked;
